var ZigInputAmount = {
	max: "CH-Ṁáx",
	info: {
		available: "CH-Áváïláblë:",
		min: "CH-Ṁïń:",
		max: "CH-Ṁáx:"
	}
};
var ZigImageInput = {
	"image-input-edit": "CH-Ëḋïṫ ïṁáĝë",
	"image-input-add": "CH-Üṗlöáḋ ïṁáĝë"
};
var ZigFilters = {
	"show-results": "CH-Ŝĥöw Ѓëŝülṫŝ",
	reset: "CH-Ѓëŝëṫ",
	min: "CH-Ṁïń",
	to: "CH-ṫö",
	max: "CH-Ṁáx",
	all: "CH-Áll",
	none: "CH-Ńöńë"
};
var ZigTable = {
	"page-x": "CH-<text>Ṗáĝë</text> <current>{{currentPage}}</current>",
	"page-x-of-all": "CH-<text>Ṗáĝë</text> <current>{{currentPage}}</current> <text>öüṫ öḟ</text> <total>{{totalPages}}</total>",
	"displaying-x-items_one": "CH-<text>Ḋïŝṗláyïńĝ</text> <selector/> <text>ïṫëṁ</text>",
	"displaying-x-items": "CH-<text>Ḋïŝṗláyïńĝ</text> <selector/> <text>ïṫëṁŝ</text>"
};
var ZigRisk = {
	"very-low-risk": "CH-Vëѓy löw ѓïŝk",
	"very-low": "CH-Vëѓy löw",
	"low-risk": "CH-Löw ѓïŝk",
	low: "CH-Löw",
	"average-risk": "CH-Ávëѓáĝë ѓïŝk",
	average: "CH-Ávëѓáĝë",
	risky: "CH-Ѓïŝky",
	"very-risky": "CH-Vëѓy ѓïŝky"
};
var ZScoreRing = {
	profits: "CH-Ṗѓöḟïṫŝ",
	risk: "CH-Ѓïŝk",
	service: "CH-Ŝëѓvïĉë",
	balance: "CH-Báláńĉë"
};
var ZigSearch = {
	search: "CH-Ŝëáѓĉĥ"
};
var zignalyUi = {
	ZigInputAmount: ZigInputAmount,
	ZigImageInput: ZigImageInput,
	ZigFilters: ZigFilters,
	ZigTable: ZigTable,
	ZigRisk: ZigRisk,
	ZScoreRing: ZScoreRing,
	ZigSearch: ZigSearch
};

export { ZScoreRing, ZigFilters, ZigImageInput, ZigInputAmount, ZigRisk, ZigSearch, ZigTable, zignalyUi as default };
